<template>
  <div>
    <div class="d-flex" v-if="isLoading">
      <div style="width: 6%">
        <b-skeleton-icon icon="question" :icon-props="{ fontScale: 3 }"></b-skeleton-icon>
      </div>
      <div class="mr-2" style="width: 82%">
        <b-skeleton width="25%"></b-skeleton>
        <b-skeleton width="95%"></b-skeleton>
      </div>
      <div>
        <b-skeleton type="button" width="100px"></b-skeleton>
      </div>
    </div>
    <div v-else class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center mr-2">
        <md-icon v-if="icon" class="mr-2 setup-guide-icon">{{ icon }}</md-icon>
        <i v-else style="margin-right: 10px" class="fas fa-coins ml-1 setup-guide-icon-font-awesome"></i>
        <div>
          <strong>{{ title }}</strong>
          <p class="mb-0 checklist-description">
            {{ description }}
          </p>
          <span style="font-size: 12px;" v-if="abbr === 'add_new_offers'">
            No new offers yet?
            <router-link class="ml-1 mt-2 text-secondary" :to="{ name: 'student-org-jobs-listing' }"
              >Explore More</router-link
            >
          </span>
          <span style="font-size: 12px;" v-if="abbr === 'add_new_research'">
            No research yet?
            <router-link class="ml-1 mt-2 text-secondary" :to="{ name: 'student-org-research-listing' }"
              >Explore More</router-link
            >
          </span>
          <span style="font-size: 12px;" v-if="abbr === 'add_certifications'">
            No certifications?
            <a
              class="ml-1 mt-2 text-secondary"
              style="font-size: 12px;"
              :href="`${getPageLink(get(getLoggedInUser, 'linked_entity.organization_site.wbst_domain'))}programs`"
              target="_blank"
              >Learn More</a
            >
          </span>
        </div>
      </div>
      <b-btn variant="primary" class="setup-guide-btn btn-normal" disabled v-if="isLoading"
        ><i class="fas fa-circle-notch fa-spin"></i
      ></b-btn>
      <b-btn
        variant="success"
        class="setup-guide-btn btn-normal d-flex align-items-center justify-content-center"
        :href="
          abbr === 'career_assessment'
            ? `${getPageLink(
                get(getLoggedInUser, 'linked_entity.organization_site.wbst_domain'),
              )}career-assessment?uuid=${get(getLoggedInUser, 'user_uuid')}`
            : null
        "
        :aria-labelledby="`${abbr}-sr-title ${abbr}-sr-desc ${abbr}-sr-earned`"
        aria-current="false"
        :to="{ name: redirectTo }"
        :target="abbr === 'career_assessment' ? '_blank' : ''"
        v-else-if="!!get(status, `${abbr}.earned`)"
      >
        <i class="material-icons icon-16pt" aria-hidden="true">stars</i>
        <span class="ml-1" aria-hidden="true">
          {{
            get(status, `${abbr}.total`)
              ? `${get(status, `${abbr}.earned`)} / ${get(status, `${abbr}.total`)}`
              : get(status, `${abbr}.earned`)
          }}
        </span>
        <div class="sr-only" aria-hidden="false">
          <span :id="`${abbr}-sr-title`">{{ title }}</span>
          <span :id="`${abbr}-sr-desc`">{{ description }}</span>
          <span :id="`${abbr}-sr-earned`">
            {{
              get(status, `${abbr}.total`)
                ? `${get(status, `${abbr}.earned`)} of ${get(status, `${abbr}.total`)} earned points`
                : `${get(status, `${abbr}.earned`)} earned points`
            }}
          </span>
        </div>
      </b-btn>
      <b-btn
        v-else
        :aria-labelledby="`${abbr}-sr-title ${abbr}-sr-desc ${abbr}-sr-btn`"
        aria-current="false"
        variant="primary"
        class="setup-guide-btn btn-normal"
        :href="
          abbr === 'career_assessment'
            ? `${getPageLink(
                get(getLoggedInUser, 'linked_entity.organization_site.wbst_domain'),
              )}career-assessment?uuid=${get(getLoggedInUser, 'user_uuid')}`
            : null
        "
        :to="{ name: redirectTo }"
        :target="abbr === 'career_assessment' ? '_blank' : ''"
        ><span :id="`${abbr}-sr-btn`">{{ btnText }}</span>
        <div class="sr-only" aria-hidden="false">
          <span :id="`${abbr}-sr-title`">{{ title }}</span>
          <span :id="`${abbr}-sr-desc`">{{ description }}</span>
        </div>
      </b-btn>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { mapGetters } from 'vuex';
import { getClickableLink } from '@/common/utils';

export default {
  name: 'GuideRow',
  props: {
    icon: { type: String, default: () => '' },
    title: { type: String, default: () => '' },
    description: { type: String, default: () => '' },
    redirectTo: { type: String, default: () => '' },
    isLoading: { type: Boolean, default: () => true },
    status: { type: Boolean, default: () => false },
    btnText: { type: String, default: () => 'Explore' },
    abbr: { type: String, default: () => '' },
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    get,

    getPageLink(url) {
      const cUrl = getClickableLink(url);
      return cUrl.endsWith('/') ? cUrl : `${cUrl}/`;
    },
  },
};
</script>

<style>
.checklist-description {
  color: #525f7f;
}

button:focus,
button:focus-visible,
.btn:focus,
.btn:focus-visible,
.setup-guide-btn:focus,
.setup-guide-btn:focus-visible {
  background: var(--dark-color);
  border: 1px solid var(--dark-color);
  /* outline-offset: 2px; */
}
</style>
